module.exports = __webpack_public_path__ + "static/media/haiwaishenbaoliucheng1.d922b437.png";